/**
 * 同時同量画面 (需要 / 需要詳細) と需要想定画面の気象データ再取得間隔 (120 秒)。
 * 需要想定画面は同時同量画面の間隔に揃える (`docs/specs/demand/demand-forecast-common.md`
 * AC-DFC-016)。
 *
 * 需要・発電の実績 / 計画データは 5 秒間隔で polling している (BalanceDemand /
 * BalanceGeneration / BalanceDemandDetail の `refetchInterval: 5_000`) が、
 * 気象データは同じ間隔では回さない。理由:
 *
 * - 裏側の DPD (BigQuery) は気象庁の更新に合わせて 10 分ごとに最新データが入る
 *   ため、5 秒間隔で叩いても同じ結果を引き直すだけ。
 * - BQ は取得ごとに課金されるため高頻度に叩きにくい。
 * - 一方でキャッシュ側も 10 分更新のため、10 分間隔で揃えると更新の取りこぼしが
 *   起きやすい。120 秒はこの取りこぼしを避けつつ BQ 課金を抑える折衷点。
 *
 * 2026-08-14 竹下さん確認済み (Slack #engineer-ebalance、「120 秒に一度で問題なし」)。
 * spec (`docs/specs/balance/doji-bg.md`) は自動更新間隔を「データソースの更新頻度に
 * 合わせる、具体値は EN 実装時に確定」と定めており、本定数がその確定値にあたる。
 */
export const WEATHER_REFETCH_INTERVAL_MS = 120 * 1000
